<template>
    <div>
        <OrderStatusForm
            :form-values="orderStatusParams || undefined"
            @on-status="onStatus($event)"
            v-if="!statusObj"
        ></OrderStatusForm>
    </div>
</template>

<script lang="ts" setup>
    import OrderStatusForm from '~/components/orders/OrderStatusForm/OrderStatusForm.vue';
    import type { OrderStatus, OrderStatusResponse } from '~/types';
    import { isError as lo_isError } from 'es-toolkit';
    import { useGlobalAlert } from 'x1-base/composables';

    const props = defineProps({
        orderStatusParams: {
            type: Object as PropType<Nilish<Partial<OrderStatus>>>,
            default: null
        }
    });
    
    const statusObj = ref<OrderStatusResponse | null>(null);
    const createGlobalAlert = useGlobalAlert();

    async function onStatus(response: OrderStatusResponse | Error): Promise<void> {
        if (lo_isError(response)) {
            createGlobalAlert({
                text: 'Could not find an Order with the values you entered. Please try again or contact customer service.',
                show: true,
                type: 'error'
            });

            return;
        }

        // Success: go to order (sales-txn) view page
        await navigateTo(`/order/${response.uid}`);
    }
</script>

<style lang="scss" scoped></style>
